import { styled } from 'styled-components';
import { StyledAlertDialogContent } from '@/shared/ui/alert-dialog/styles';
import { Box } from '@/shared/ui/box/Box';

const StyledMultDialogContent = styled(StyledAlertDialogContent)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 420px;
  padding: 18px;
  box-sizing: border-box;
  max-height: 730px;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    padding-bottom: calc(18px + var(--app-safe-area-bottom));
  }
`;

const Navigation = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const CloseButton = styled.button`
  display: flex;
  padding: 4px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  background: transparent;

  &:hover {
    opacity: 0.8;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const Details = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ButtonsContainer = styled(Box)`
  position: absolute;
  bottom: var(--app-safe-area-bottom);
  left: 0;
  width: 100%;
  padding: 18px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-top: 24px;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export {
  InfoContainer,
  Details,
  StyledMultDialogContent,
  Navigation,
  CloseButton,
  ButtonsContainer
};
